import { render, staticRenderFns } from "./previewDetail.vue?vue&type=template&id=8a763452&scoped=true"
import script from "./previewDetail.vue?vue&type=script&lang=js"
export * from "./previewDetail.vue?vue&type=script&lang=js"
import style0 from "./previewDetail.vue?vue&type=style&index=0&id=8a763452&prod&lang=scss&scoped=true"
import style1 from "./previewDetail.vue?vue&type=style&index=1&id=8a763452&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a763452",
  null
  
)

export default component.exports